module.exports = __webpack_public_path__ + "img/PT36.f21a2f12.png";